import { FC, useState, useCallback, useEffect } from "react";
import { Alert, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAppSelector } from "@/store/hooks";
import { dimensionCategoriesLengthSelector } from "@/store/dimensions/selectors/slice-data/categories/dimensionCategoriesLengthSelector";
import { currentDimensionCategoriesLength } from "@/store/dimensions/selectors/dimensions-data/currentDimensionCategoriesLength";
import { dimensionSharedCostsWithEvenSplitMethodExistsSelector } from "@/store/dimensions/selectors/shared-costs/dimensionSharedCostsWithEvenSplitMethodExistsSelector";

export const EvenSplitAllocationRuleAlertMessage: FC = () => {
  const [needToShowAlert, setNeedToShowAlert] = useState(false);

  const existingCategoriesLength = useAppSelector(
    dimensionCategoriesLengthSelector,
  );
  const originalCategoriesLength = useAppSelector(
    currentDimensionCategoriesLength,
  );
  const dimensionSharedCostsWithEvenSplitMethodExists = useAppSelector(
    dimensionSharedCostsWithEvenSplitMethodExistsSelector,
  );

  const messageHideHandler = useCallback(() => setNeedToShowAlert(false), []);

  useEffect(() => {
    if (
      existingCategoriesLength > originalCategoriesLength &&
      dimensionSharedCostsWithEvenSplitMethodExists
    ) {
      setNeedToShowAlert(true);
    }
  }, [
    existingCategoriesLength,
    dimensionSharedCostsWithEvenSplitMethodExists,
    originalCategoriesLength,
  ]);

  if (!needToShowAlert) {
    return null;
  }

  return (
    <Alert
      severity="info"
      variant="outlined"
      action={
        <IconButton onClick={messageHideHandler} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    >
      <Typography variant="body2">
        This Dimension has a cost allocation rule using the{" "}
        <Typography fontWeight="bold" component="span" variant="body2">
          Even Split
        </Typography>{" "}
        method. Since you added a new category, the cost will now be evenly
        divided across all categories. Review the allocation if needed.
      </Typography>
    </Alert>
  );
};
